// utils/copyToClipboard.ts
export const copyToClipboard = async (text: string ): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true; // copied successfully
  } catch (err) {
    console.error("Failed to copy text: ", err);
    return false;
  }
};
